module.exports = __webpack_public_path__ + "static/media/loginImg2.bd2e2404.png";